var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfflineStorageAssuranceH5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 81,
    viewBox: "0 0 160 81",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_437_3402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.000244141 0.566406H160V80.5664H-0.000244141V0.566406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99976 70.9668H46.3998",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.2 77.3672C153.2 60.7986 139.768 47.3672 123.2 47.3672",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9998 32.566C47.9998 29.0314 50.8651 26.166 54.3998 26.166H116.8C120.334 26.166 123.2 29.0314 123.2 32.566V70.966H47.9998V32.566Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.59961 72.5664C5.59961 39.4293 32.4625 12.5664 65.5996 12.5664",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeDasharray: "2.4 1.6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.59983,
    cy: 70.9664,
    r: 2.4,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1767 28.5602C33.1767 32.4003 30.0637 35.5133 26.2236 35.5133C22.3835 35.5133 19.2705 32.4003 19.2705 28.5602C19.2705 24.7201 22.3835 21.6071 26.2236 21.6071C30.0637 21.6071 33.1767 24.7201 33.1767 28.5602Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9927 31.354C26.2552 31.354 26.4963 31.4481 26.6856 31.6052L25.9927 32.4846L25.2999 31.6052C25.4892 31.4481 25.7302 31.354 25.9927 31.354ZM22.6149 25.0957L29.1107 31.7576L28.591 32.2906L26.6877 30.3381C26.4692 30.2637 26.2356 30.2234 25.9927 30.2234C25.4679 30.2234 24.986 30.4115 24.6074 30.7255L24.1457 30.139C24.6146 29.7502 25.2024 29.5062 25.8444 29.4735L24.8904 28.4952C24.3585 28.6494 23.8712 28.9126 23.4528 29.2597L22.9909 28.6733C23.3836 28.3477 23.8275 28.0845 24.3084 27.8987L23.4689 27.0371C23.0489 27.2422 22.6564 27.4968 22.2985 27.7936L21.8365 27.2073C22.1725 26.9287 22.5355 26.6832 22.921 26.4755L22.0952 25.6287L22.6149 25.0957ZM26.9115 28.4467L26.0723 27.5863L25.9927 27.5854C27.1299 27.5854 28.1743 27.993 28.9946 28.6734L28.5327 29.2597C28.0666 28.873 27.515 28.5906 26.9115 28.4467ZM25.9927 25.7012C27.5672 25.7012 29.0132 26.2654 30.149 27.2074L29.6869 27.7936C28.6774 26.9563 27.3922 26.4549 25.9927 26.4549C25.6701 26.4549 25.3535 26.4815 25.0449 26.5328L24.4217 25.8937C24.9252 25.7679 25.4514 25.7012 25.9927 25.7012Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4001 11.7672C58.4001 8.23257 61.2655 5.36719 64.8001 5.36719L106.4 5.36719C109.935 5.36719 112.8 8.23256 112.8 11.7672L112.8 70.9672L58.4001 70.9672L58.4001 11.7672Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.6 70.9668H65.5996C65.5996 59.9211 74.5539 50.9668 85.5996 50.9668C96.6453 50.9668 105.6 59.9211 105.6 70.9668Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7996 72.5672C40.7996 75.2182 42.9486 77.3672 45.5996 77.3672H125.6C128.251 77.3672 130.4 75.2182 130.4 72.5672V70.9672H40.7996V72.5672Z",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5996 74.166H93.5996",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.3996,
    cy: 13.3656,
    rx: 1.6,
    ry: 1.60001,
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.0001,
    cy: 13.3656,
    rx: 1.6,
    ry: 1.60001,
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7996 21.3672H96.7996",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7996 25.3672H80.7996",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.599 44.7191L147.999 42.166L159.199 45.8926V52.4017C159.199 59.4121 154.674 65.6208 147.999 67.766C142.031 65.8477 139.065 59.1593 141.649 53.448L145.599 44.7191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.999 42.166L145.599 44.7191L141.649 53.448C139.065 59.1593 142.031 65.8477 147.999 67.766V67.766V67.766C154.674 65.6208 159.199 59.4121 159.199 52.4017V45.8926L147.999 42.166ZM147.999 42.166L136.799 45.8926L134.599 48.5191",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.4 48.293L145.6 44.5664L156.8 48.293V54.8021C156.8 61.8125 152.274 68.0211 145.6 70.1664C138.926 68.0211 134.4 61.8125 134.4 54.8021V48.293Z",
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142 58.2839L146.698 50.9668L146.207 55.9424H149.2L144.734 62.9668L145.225 58.2839H142Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9625 37.7656L85.9625 66.5656M85.9625 66.5656L93.0266 59.792M85.9625 66.5656L78.6266 59.792",
    stroke: "black",
    strokeWidth: 1.33333
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_437_3402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 80,
    fill: "white",
    transform: "translate(0 0.566406)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfflineStorageAssuranceH5);
export default __webpack_public_path__ + "static/media/offline_storage_assurance_h5.cc8427aededbdb3e6f4581b76c98142c.svg";
export { ForwardRef as ReactComponent };